import ReviewMethodologyModal from './ReviewMethodologyModal'

export default ReviewMethodologyModal
